import React from "react";
import MaterialRequestTable from "./MaterialRequestTable";
import MaterialRequestHistoryTable from "./MaterialRequestHistoryTable";
import {MaterialRequestSectionApp} from "../../Functionality/MaterialRequest/MaterialRequestSectionApp";
import {SUB_VIEW_MODEL} from "../../Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Requests tab of material control.
 *
 * Shows the requests that are still in course, where they are approved, or the
 * history of the ones that already ended.
 */
const MaterialRequestSection = ({
    subView,
    setSubView,
    setOption,
    setModuleId,
    setBodyForExport,
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option,
    searchElement,
    setSearchElement,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    setFinalArray,
    finalArray,
    modified,
    setModified,
    setCriteria
}) => {
    const {
        handleBtnRequest,
        handleBtnHistory,
        isSubViewReady
    } = MaterialRequestSectionApp({
        subView,
        option,
        setSubView,
        setOption,
        setModuleId,
        setFinalArray,
        setSearchElement,
        setSearch,
        setCriteria
    });

    return (
        <>
            {isSubViewReady(SUB_VIEW_MODEL.REQUESTS.REQUEST) && (
                <MaterialRequestTable
                    optionView={subView}
                    handleBtnRequest={handleBtnRequest}
                    handleBtnHistory={handleBtnHistory}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    option={option}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    finalArray={finalArray}
                    modified={modified}
                    setModified={setModified}
                    setCriteria={setCriteria}
                />
            )}
            {isSubViewReady(SUB_VIEW_MODEL.REQUESTS.HISTORY) && (
                <MaterialRequestHistoryTable
                    optionView={subView}
                    handleBtnRequest={handleBtnRequest}
                    handleBtnHistory={handleBtnHistory}
                    option={option}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    finalArray={finalArray}
                    modified={modified}
                    setModified={setModified}
                    setCriteria={setCriteria}
                />
            )}
        </>
    );
};

export default MaterialRequestSection;
